import React from "react";
import { PageContainer } from "./styles";
import Header from "./components/header";
import DevsSebrae from "./components/devsSebrae";
import Integration from "./components/integration";
import AboutSebraeApi from "./components/aboutSebraeApi";
import WhoCanUse from "./components/whoCanUse";
import Functionality from "./components/functionality";
import GeneralDoubts from "./components/generalDoubts";
import Suggestion from "./components/suggestion";
import Footer from "./components/footer";

const App = () => {
  return (
    <PageContainer>
      <Header />
      <DevsSebrae />
      <AboutSebraeApi />
      <WhoCanUse />
      <Integration />
      <Functionality />
      <GeneralDoubts />
      <Suggestion />
      <Footer />
    </PageContainer>
  );
};

export default App;
